<template>
	<div id="useradd">
		<div class="bm_h">
			<h3>用户密码修改</h3>
		</div>
		<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
			
			<Row type="flex" justify="center" align="middle">
				<FormItem label="用户名" prop="userLoginId">
					<Input v-model="formValidate.userLoginId" disabled placeholder="请输入用户名"></Input>
				</FormItem>
			</Row>
		 
		 <Row type="flex" justify="center" align="middle">
		 	<FormItem label="旧密码" prop="oldPassword">
		 		<Input type="password" v-model="formValidate.oldPassword"></Input>
		 
		 	</FormItem>
		 </Row>
		 
		     <Row type="flex" justify="center" align="middle">
		     	<FormItem label="密码" prop="userPassword">
		     		<Input type="password" v-model="formValidate.userPassword"></Input>	
		     	</FormItem>
		     	 <div id="note">
		     		 <div>
		     		提示:密码由字母+数字组成且总长度4-16位
		     		</div>
		     	 </div>
		     	 
		     </Row>
			 
			 <Row type="flex" justify="center" align="middle">
			 	<FormItem label="确认密码" prop="userPasswordCheck">
			 		<Input type="password" v-model="formValidate.userPasswordCheck"></Input>
			 
			 	</FormItem>
			 </Row>
			 
			<Row justify="center" align="middle">
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 20px">重置</Button>
				</FormItem>
			</Row>
		</Form>
	</div>
</template>




<script>
	import {
		editUserPassWord,
	} from '@/network/index.js';
	import intiHeadImage from "@/assets/image/element/headPhoto/1.png";


 
 

	export default {
		name: 'UserInfo',
		components: {

		},
		data() {
 
            //判断密码输入的是否正确
            const validatePass = (rule, value, callback) => {
            	if (value === '') {
            		callback(new Error('请输入密码'));
            	} else {
            		//  密码长度最少8位、必须包含字母和数字 必须包含$或*号
            		console.log("-------:" + value.length)
            		//                if(value.length<8){
            		//  callback(new Error('密码长度小于8位数！'));
            		// }
            		//密码验证
            		//let passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}/
					let passwordreg = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{4,16}$/;
            		let isValid = passwordreg.test(value);
            		if (isValid != true) {
            			callback(new Error('密码由字母+数字组成且总长度4-16位！'));
            		}
            
            
            		if (this.formValidate.userPasswordCheck !== '') {
            			// 对第二个密码框单独验证
            			this.$refs.formValidate.validateField('userPasswordCheck');
            		}
            		callback();
            	}
            };
            //判断确认密码是否输入以及和第一次输入的是否一致
            const validatePassCheck = (rule, value, callback) => {
            	if (value === '') {
            		callback(new Error('请再次输入密码'));
            	} else if (value !== this.formValidate.userPassword) {
            		callback(new Error('两次输入的密码不一样!'));
            	} else {
            		callback();
            	}
            };
 
			return {
				formValidate: {
					oldPassword: '',
					userPassword: '',
					userPasswordCheck: '', 
				},
                
				ruleValidate: {
					oldPassword: [{
						required: true,
						message: '旧密码是必填项',
						trigger: 'blur' //失去焦点事件
					}],
					userPassword: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}],
					userPasswordCheck: [{
						required: true,
						validator: validatePassCheck,
						trigger: 'blur'
					}],

				}
			}
		},


		created() {
			
			this.formValidate.userLoginId  = this.$store.state.userInfo.loginId;
			
		 

		},

		methods: {
 
			handleSubmit(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {
						
						 
						let paramter = {
							userLoginId: this.formValidate.userLoginId,
							newPassword: this.formValidate.userPassword,
							oldPassword: this.formValidate.oldPassword,
						};

						editUserPassWord(paramter).then(res => {
							debugger;
							if(res.success==true){
								 this.$Message.success(res.message);
							}else{
								this.$Message.error(res.message);
							}

							})
							.catch(error => {
								this.$Message.success('修改失败，请联系管理员!');
							});


					} else {
						this.$Message.error('数据校验失败，请修改后重新提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}
		}
	}
</script>

<style lang="scss" scoped>
 
 
	#note {
		position: absolute;
		left: 74%;
		top: 32%;
	}
	
	.ivu-form-item {
		margin-bottom: 10px;
		margin-top: 10px;
	}
	
	.bm_h {
		padding: 0 10px;
		height: 50px;
		border-top: 1px solid #FFF;
		border-bottom: 1px solid #e3e2db;
		background: #F2F2F2;
		line-height: 50px;
	
	}
	
	
	.ivu-input-wrapper {
		width: 300px;
	
	}
	
	.ivu-form-item-label {
		text-align: center;
	}
	
	.ivu-form-item-content {
		text-align: left;
	}
	
	.ivu-select {
		width: 300px;
	}
	
	
	 
	// #head {
	// 	line-height: 20px;
	// 	top: 42px;
	// 	left: 10px;
	// 	position: relative;
	// }
	
	#head-logo {
		width: 60px;
		height: 60px;
		border-radius: 3px; //添加圆角
		//position: relative;
		//left: 300px;
	
	}
	
	#head-select {
		width: 200px;
		height: 30px;
		bottom: 20px;
		border-radius: 1px; //添加圆角
		position: relative;
		left: 300px;
	
	}
	
	label {
		position: relative;
	}
	
	#fileinp {
		position: absolute;
		left: 0px;
		top: 0;
		opacity: 0;
	}
	
	#btn {
		margin-right: 5px;
	}
	
	
	#head-word {
		width: 60px;
		height: 20px;
		position: relative;
		bottom: 25px;
		// top: 15px;
		left: 10px;
	}
	
	#imageId {
		width: 120px;
		height: 30px;
		position: absolute;
		left: 180px;
		top: 2px;
	}
	
	#useradd {
		border-style: solid;
		border-width: 1px;
		border-color: #bebdbc;
	}
	
	#noteWord {
		position: absolute;
		left: 61%;
		top: 47%;
	}
</style>
